/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import MountainsSvg from "../../assets/images/header-mountains.svg?react";

const HeaderMountains = () => (
  <MountainsSvg
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
    tabIndex={-1}
    className="pointer-events-none absolute top-full left-0 -mt-px block aspect-[1024/46] w-full"
  />
);

export default HeaderMountains;
